import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const UncheckedIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="1" y="1" width="18" height="18" rx="2" fill={fillColor || '#F6F6F7'} />
      <rect x="1" y="1" width="18" height="18" rx="2" stroke="#9D9DA6" strokeWidth="2" />
    </svg>
  );
};

export { UncheckedIcon };
